import { StateCreator } from "zustand";

import {
  RollForwardWizardStore,
  SourceTargetActions,
  SourceTargetSlice
} from "../roll_forward_wizard_store_types";

export const createSourceTargetSlice: StateCreator<
  RollForwardWizardStore,
  [["zustand/immer", never]],
  [],
  SourceTargetSlice
> = () => ({
  sourceTarget: {}
});

export const createSourceTargetActions = (): SourceTargetActions => ({});
